import { FC, memo } from 'react'
import { get } from 'lodash'
import * as Analytics from 'core/common/analytics'
import { VariationValue } from 'core/components/Multivariation'
import { BULK_FIELD_NAME } from 'core/components/Multivariation/constants'
import { TFormValues } from 'core/components/Multivariation/types'
import { useFormContext } from 'core/pages/ProductNew-v2/context/ProductNewContext'
import { TProductInitialValues } from 'core/pages/ProductNew-v2/types'
import { IStoreValues, useMultivariationValues } from '../store'
import { FlowCardProps } from '../types'
import { getFirstVariationFields } from './utils'

const FirstVariationValue: FC<FlowCardProps> = ({ onNext, handleEditStep, step, formMode }) => {
  const { setFormData } = useFormContext()
  const { getType, getValues, setValues } = useMultivariationValues()

  const variationType = getType('first')
  const storeValues = getValues()

  if (!variationType) {
    return null
  }

  const handleSubmit = (values: TFormValues) => {
    const newValues = {} as IStoreValues['variationValues']

    values[BULK_FIELD_NAME].forEach(({ title }) => {
      newValues[title] = get(storeValues, title, {})
    })

    Analytics.ProductVariationAttributeSaved(formMode)

    setValues(newValues)
    setFormData((prevData: TProductInitialValues) => ({
      ...prevData,
      selectedAttributes: newValues,
    }))

    onNext()
  }

  const fields = getFirstVariationFields(variationType, storeValues)

  return (
    <VariationValue
      onSubmit={handleSubmit}
      variationType={variationType}
      fields={fields}
      onChange={() => handleEditStep(step.key)}
      handleEditStep={handleEditStep}
      formMode={formMode}
    />
  )
}

export default memo(FirstVariationValue)
